var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hiddenScrollbar detail" }, [
    _c(
      "div",
      { staticClass: "Hotel-Info box" },
      [
        _c("w-image", {
          ref: "wImage",
          attrs: {
            pictures: _vm.community.pictures,
            name: "外观",
            state: _vm.community.state,
            brandName: _vm.community.otherResourceData
              ? _vm.community.otherResourceData.brandName
              : "",
          },
          nativeOn: {
            click: function ($event) {
              return _vm.showImages.apply(null, arguments)
            },
          },
        }),
        _c("div", { staticClass: "Right" }, [
          _c("div", { staticClass: "Right-Top" }, [
            _c("div", { staticClass: "Right-One Right-Padding" }, [
              _vm.community.score
                ? _c("span", [
                    _vm._v(_vm._s(_vm.community.score)),
                    _c("span", { staticStyle: { "font-size": "15px" } }, [
                      _vm._v("分"),
                    ]),
                  ])
                : _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v("暂无评分"),
                  ]),
            ]),
            _c("div", { staticClass: "Right-One-Hotel Right-Padding" }, [
              _c("p", [
                _vm._v(
                  "品牌：" + _vm._s(_vm.community.otherResourceData.brandName)
                ),
              ]),
              _c("p", [
                _vm._v(
                  "房间数：" + _vm._s(_vm.community.otherResourceData.roomCount)
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "Right-Two Right-Padding" },
              [
                _vm.community.star
                  ? _c("el-rate", {
                      attrs: { max: _vm.community.star, disabled: "" },
                      model: {
                        value: _vm.community.star,
                        callback: function ($$v) {
                          _vm.$set(_vm.community, "star", $$v)
                        },
                        expression: "community.star",
                      },
                    })
                  : _vm._e(),
                _vm.community.addressCn || _vm.community.address
                  ? _c("i", {
                      staticClass: "el-icon-location-outline van-icon",
                    })
                  : _vm._e(),
                _c("span", { staticClass: "ellipsis" }, [
                  _vm._v(
                    _vm._s(_vm.community.addressCn || _vm.community.address)
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
    _vm.community.introduction
      ? _c("div", { staticClass: "Introduce box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "jianjie" },
              }),
              _vm._v("简介"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v(_vm._s(_vm.community.introduction))]
          ),
        ])
      : _vm._e(),
    _vm.community.introduction
      ? _c("div", { staticClass: "Service box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "hotelsheshi" },
              }),
              _vm._v("酒店设施"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [
              _vm._v(
                _vm._s(
                  _vm.community.otherResourceData.facCheck
                    .map((x) => x.content)
                    .join("、")
                )
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm.community.hotelInfoPolicy
      ? _c("div", { staticClass: "Policy box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "hotelzhengce" },
              }),
              _vm._v("酒店政策"),
            ],
            1
          ),
          _vm.community.hotelInfoPolicy.checkInTime
            ? _c(
                "p",
                {
                  staticClass: "box-content",
                  staticStyle: { color: "#323232" },
                },
                [
                  _c("b", [_vm._v("入住时间：")]),
                  _vm._v(_vm._s(_vm.community.hotelInfoPolicy.checkInTime)),
                ]
              )
            : _vm._e(),
          _vm.community.hotelInfoPolicy.checkOutTime
            ? _c(
                "p",
                {
                  staticClass: "box-content",
                  staticStyle: { color: "#323232" },
                },
                [
                  _c("b", [_vm._v("退房时间：")]),
                  _vm._v(_vm._s(_vm.community.hotelInfoPolicy.checkOutTime)),
                ]
              )
            : _vm._e(),
          _vm.community.hotelInfoPolicy.children
            ? _c(
                "p",
                {
                  staticClass: "box-content",
                  staticStyle: { color: "#323232" },
                },
                [
                  _c("b", [_vm._v("儿童政策：")]),
                  _vm._v(_vm._s(_vm.community.hotelInfoPolicy.children)),
                ]
              )
            : _vm._e(),
          _vm.community.hotelInfoPolicy.pet
            ? _c(
                "p",
                {
                  staticClass: "box-content",
                  staticStyle: { color: "#323232" },
                },
                [
                  _c("b", [_vm._v("是否携带宠物：")]),
                  _vm._v(_vm._s(_vm.community.hotelInfoPolicy.pet)),
                ]
              )
            : _vm._e(),
          _vm.community.hotelInfoPolicy.cancel
            ? _c(
                "p",
                {
                  staticClass: "box-content",
                  staticStyle: { color: "#323232" },
                },
                [
                  _c("b", [_vm._v("取消政策：")]),
                  _vm._v(_vm._s(_vm.community.hotelInfoPolicy.cancel)),
                ]
              )
            : _vm._e(),
          _vm.community.hotelInfoPolicy.acceptCreditCards
            ? _c(
                "p",
                {
                  staticClass: "box-content",
                  staticStyle: { color: "#323232" },
                },
                [
                  _c("b", [_vm._v("是否支持信用卡：")]),
                  _vm._v(
                    _vm._s(_vm.community.hotelInfoPolicy.acceptCreditCards)
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _c("div", { staticClass: "Traffic box box-kuang" }, [
      _c(
        "p",
        { staticStyle: { display: "flex" } },
        [
          _c("svg-icon", {
            staticClass: "icon-title",
            attrs: { iconClass: "guanwang" },
          }),
          _vm._v("官网及联系电话"),
        ],
        1
      ),
      _vm.community.website
        ? _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v("web：" + _vm._s(_vm.community.website))]
          )
        : _vm._e(),
      _vm.community.phone
        ? _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v("phone：" + _vm._s(_vm.community.phone))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }